import { Link, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  copyrightPanel: {
    padding: '1rem',
    borderTop: '#4c4c4c 1px solid',
  }
}));

export default () => {
  const classes = useStyles();

  const FooterLine = ({ children }) => (
    <Typography variant="body2" color="textSecondary" align="center">{children}</Typography>
  );

  return (
    <div className={classes.copyrightPanel}>
      <FooterLine>
        <Link color="inherit" href="//symphony.com/privacy-policy/" target="_blank" rel="noopener">
          Symphony Privacy Policies &amp; Terms
        </Link>
      </FooterLine>
      <FooterLine>
        Copyright &copy;{new Date().getFullYear()}
        {' '}
        <Link color="inherit" href="//symphony.com" target="_blank" rel="noopener">
          Symphony Communications LLC
        </Link>
      </FooterLine>
    </div>
  );
}
